export default {
  methods: {
    getState(field) {
      if (!field.$dirty) {
        return null;
      }

      return !field.$invalid;
    },
  },
};
